
<div
  class="feature-card"
  @click="setActive"
  :class="{ active: isActive }"
>
  <div :class="['feature-label', isActive ? 'feature-label-active' : 'feature-label-inactive']" :style="{ backgroundColor: labelBackgroundColor, color: labelTextColor }">
    <div class="flex lg:flex-col justify-between lg:items-center w-full h-full gap-1 lg:gap-0">
      <p class="column-text">{{ feature.columnText }}</p>
      <div class="w-full lg:flex lg:flex-col lg:items-center">
        <h2 class="vertical-text">{{ feature.verticalText }}</h2>
        <p class="horizontal-text">{{ feature.horizontalText }}</p>
      </div>
    </div>
  </div>
  <transition name="slide-fade">
    <div class="feature-content" v-if="isActive" :style="{ backgroundColor: featureContentBackgroundColor, color: featureContentTextColor }">
      <div>
        <h3 class="feature-heading">{{ feature.heading }}</h3>
        <p class="feature-description" v-html="decodedDescription"></p>
          <div class="feature-image"
            :style="{ backgroundImage: `url(${imgSrcs})` }"
          ></div>
      </div>
    </div>
  </transition>
</div>
